export const initialState = {
  fetching: false,
  selectedLanguage: undefined,
  data: {
    en: {
      catalog: {},
      configs: {},
      items: {},
      language: 'en',
      uiTags: {
        addressLineLabel: 'Address Line',
        agree: 'Agree',
        answersErrorMessage: 'Error: Please check your answers for more info',
        builtWith: 'Built with',
        cameraOrMicAccessDeniedByUser: 'You have denied access to your camera or microphone.',
        cameraOrMicDeniedHowToResolve:
          'To enable them, please update your permissions in your browser settings or click “Next page” to continue.',
        cancel: 'Cancel',
        cannotConnectToCameraOrMic: 'We encountered an error when trying to connect to your camera and/or microphone.',
        chooseFileLabel: 'Choose file',
        clickNextPageToContinue: 'Click "Next page" to continue.',
        clickToCloseLink: 'Close',
        clickToDisplayLink: 'Continue',
        conceptTestLinkLabel: 'Please click the video below to begin. Make sure your volume is turned up.',
        conceptTestLinkLabelNoAudio: 'Please click the video below to begin.',
        conjointNoneOfTheseLabel: 'I would not purchase any of these products',
        constantSumTotalLabel: 'Total',
        constantSumValueInputPlaceholder: 'Value',
        countryLabel: 'Country',
        dayLabel: 'Day',
        declineVideoSubmission: 'I do not want to submit a video',
        declineVideoSubmissionConfirmation:
          'Are you sure? If you do not submit a video, you will be disqualified from the survey.',
        delete: 'Delete',
        disagree: 'Disagree',
        disqualifiedMessage: 'You are currently not a good fit for this survey.\nThank you so much for your time.',
        dragLabel: 'or drag here',
        dropdownSelectionLabel: 'Select an option',
        emailLabel: 'Email',
        enableCamera: 'Enable camera',
        enableCameraOrNextToExit:
          'Select "Next page" to exit the survey, or click "Enable camera" to record your video response.',
        endingIn: 'Ending in',
        eraseLabel: 'Erase',
        faceAndShouldersOffFrame: 'Center head and shoulders in frame',
        faceNotDetectedDesktop: 'Your face must be visible while answering the prompt',
        faceNotDetectedMobile: 'Face must be visible while answering',
        faceNotFullyShown: 'Face partially hidden',
        faceNotVisible: 'Face not visible',
        faceTooClose: 'Face too close to the camera',
        faceTooFar: 'Face too far from the camera',
        fileSizeLimitError: 'Files must be smaller than {VALUE_TAG_0} MB',
        firstNameLabel: 'First Name',
        for: '{VALUE_TAG_0} for {VALUE_TAG_1}',
        genericErrorMessage: 'An error occurred, please try again. If the error persists, please contact us.',
        genericThankYouMessageLabel:
          'Thank you for completing this survey.\nClick on the button below to submit your responses.',
        greaterThan: 'Should be greater than or equal to {VALUE_TAG_0}',
        heatmapCommentsPlaceholder: 'Please explain your reaction',
        heatmapDeleteReaction: 'Delete Reaction',
        heatmapMinClicks: 'The minimum number of clicks required is {VALUE_TAG_0}',
        heatmapModalTitle: 'Select an option to provide feedback',
        inputPlaceholder: 'Your answer here',
        inSet: '{VALUE_TAG_0} on set {VALUE_TAG_1}',
        inSets: '{VALUE_TAG_0} on sets {VALUE_TAG_1}',
        invalidDate: 'Please select a valid date',
        invalidEmail: '{VALUE_TAG_0} is not a valid email address',
        invalidImageExtensionError: 'Only {VALUE_TAG_0} file types are accepted',
        invalidPhoneNumber: '{VALUE_TAG_0} is not a valid phone number',
        invalidValue: 'Invalid value for {VALUE_TAG_0}',
        invalidZipCode: '{VALUE_TAG_0} is not a valid zip code',
        invalidPostalCode: '{VALUE_TAG_0} is not a valid postal code',
        language: 'en',
        lastNameLabel: 'Last Name',
        lessThan: 'Should be less than or equal to {VALUE_TAG_0}',
        limitImagesLabel: '{VALUE_TAG_0} images maximum',
        loadingLabel: 'Loading',
        maximum: 'Maximum',
        maxFileSizeLabel: 'Max file size {VALUE_TAG_0} MB',
        maxImagesToUploadError: 'Maximum {VALUE_TAG_0} images can be uploaded',
        maxImageToUploadError: 'Maximum 1 image can be uploaded',
        minimum: 'Minimum',
        monthLabel: 'Month',
        mustSumToRange: 'All values must sum up to a value between {VALUE_TAG_0} and {VALUE_TAG_1}',
        mustSumToTotal: 'All values must sum up to {VALUE_TAG_0}',
        next: 'Next',
        nextPage: 'Next Page',
        noneLabel: 'None',
        npsCommentsPlaceholder: 'Please explain your score',
        numericMatrixColumnTotal: 'Column total',
        numericMatrixError: 'Total',
        numericMatrixInputPlaceholder: 'Value',
        numericMatrixRequiredTotal: 'Required total',
        numericMatrixRowTotal: 'Row total',
        okLabel: 'OK',
        optionGreaterThan: '{VALUE_TAG_0} must be greater than {VALUE_TAG_1}',
        optionGreaterThanOrEqualTo: '{VALUE_TAG_0} must be greater than or equal to {VALUE_TAG_1}',
        optionLessThan: '{VALUE_TAG_0} must be less than {VALUE_TAG_1}',
        optionLessThanOrEqualTo: '{VALUE_TAG_0} must be less than or equal to {VALUE_TAG_1}',
        overQuotaMessage: 'We’ve met our limit of responses for this survey. Thank you so much for your time',
        orLabel: 'or',
        phoneLabel: 'Phone',
        photoLibraryLabel: 'Photo library',
        postalCodeLabel: 'Postal Code',
        prev: 'Previous',
        prevPage: 'Previous Page',
        promptForAddress: 'Please enter the address',
        promptForAnswers: 'Error: Please answer the survey',
        promptForComments: 'Include an explanation of your choice.',
        promptForCountry: 'Please choose a country',
        promptForDate: 'Please select a date',
        promptForEmail: 'Please enter the email address',
        promptForFirstName: 'Please enter the first name',
        promptForLastName: 'Please enter the last name',
        promptForNPSComments: 'Please explain your score',
        promptForOption: 'Please choose an option',
        promptForOptionPerRow: 'Please choose an option for every row',
        promptForPhoneNumber: 'Please enter the phone number',
        promptForRankAllOptions: 'Please rank all options',
        promptForRankOptions: 'Please rank exactly {VALUE_TAG_0} options',
        promptForRankOptionsInOrder: 'Ranking needs to be in sequential order starting from 1',
        promptForState: 'Please choose a state',
        promptForUniqueOptionPerRow: 'Please choose a different option for every row',
        promptForValidDecimal: 'Should be a valid decimal',
        promptForValidNumber: 'Should be a valid number',
        promptForPostalCode: 'Please enter the postal code',
        promptForZipCode: 'Please enter the zip code',
        rankDesktopBottomPlaceholder: 'Drag and drop options here, or click on options to rank them.',
        rankDesktopTopPlaceholder: 'Drag and drop options here, or click on options to rank them.',
        rankInfoLabel: 'Remember to either drag and drop or click to add options',
        rankMobileBottomPlaceholder: 'Please select this number of options:',
        rankMobilePlaceholder:
          'Tap options to rank them, and drag options to reorder. Tap ranked options to remove them.',
        required: 'Required',
        requiredMaxOptions: 'Maximum number of options required: {VALUE_TAG_0}',
        requiredMaxWords: 'Response is {VALUE_TAG_0} words over the {VALUE_TAG_1}-word limit. Shorten it to continue.',
        requiredMinCharacters: 'Response needs at least {VALUE_TAG_0} characters. Add more to continue.',
        requiredMinOptions: 'Minimum number of options required: {VALUE_TAG_0}',
        requiredMinOptionsPerRow: 'Minimum number of options per row required: {VALUE_TAG_0}',
        requiredMinWords: 'Response needs at least {VALUE_TAG_0} words. Add more to continue.',
        requiredOptionInSet: 'Please choose {VALUE_TAG_0} option',
        requiredOptionPerColumn: 'Please choose one option in each column.',
        requiredOptions: 'Number of options required: {VALUE_TAG_0}',
        requiredOptionsInSet: 'Please choose {VALUE_TAG_0} options',
        requiredOtherOption: 'Other option is required',
        requiredRangeOptionsPerRow: 'Between {VALUE_TAG_0} and {VALUE_TAG_1} options per row required:',
        requirementsNotCompleted: 'You have not completed all requirements',
        reRecord: 'Re-record',
        resetLabel: 'Reset',
        save: 'Save',
        stateLabel: 'State',
        submit: 'Submit',
        surveyProgressBarLabel: 'completed',
        takePhotoLabel: 'Take photo',
        termsAndConditionsLabel: 'I agree with Terms And Conditions',
        termsAndConditionsModalTitle: 'Terms & Conditions',
        textHighlightPlaceHolderDesktop: 'Select a category, and click on or drag over the text to highlight it.',
        textHighlightPlaceHolderMobile: 'Please select the text first, and then select the category.',
        textHighLightTitle: 'Highlight some text',
        unsubscribedError: 'Service unavailable. Please try again later.',
        unsubscribeDescription: 'Are you sure you want to unsubscribe from our mailing list?',
        unsubscribedMessage: 'You have been successfully unsubscribed from our mailing list.',
        unsubscribeLabel: 'Unsubscribe',
        videoIsRequiredOnNextQuestion: 'The next question requires a video response',
        videoIsRequiredOnThisQuestion: 'This question requires a video response',
        videoTooShort: 'Recorded video is too short',
        weAreSorryMessage: "We're sorry.",
        yearLabel: 'Year',
        zipCodeLabel: 'Zip Code',
      },
      welcome: {},
    },
  },
};
